import styled from 'styled-components'

export type CategoriesProps = {
  isSelected: boolean
}

export const CategoriesMainContainer = styled.div`
  padding: 0 20px;
`

export const CategoriesContainer = styled.div<CategoriesProps>`
  cursor: pointer;
  padding-bottom: 10px;
  border-bottom: ${(props) => (props.isSelected ? '4px solid #4B286D' : 'inherit')};
`

export const CategoryName = styled.div<CategoriesProps>`
  font-weight: ${(props) => (props.isSelected ? 'bold' : 'normal')};
  color: #54595f;
`
